import React, {useContext, useEffect} from "react";
import { UserContext } from '../Context/UserContext'
import "../styles/paymentConfirmed.css"

function PaymentConfirmed() {
    const {state, fetchUserData} = useContext(UserContext);

    useEffect(() => {
        fetchUserData()
    }, [])

    return (
        <div className="paymentSuccessful">
            <h3>Payment Successful. Enjoy your premium membership!</h3>
            <p>If you purchased a monthly subscription, you won't be charged until after the 5 day free trial</p>
            {state?.loggedIn && (<p>You should receive a receipt at {state.user.email}</p>)}
        </div>
    )
}

export default PaymentConfirmed